import React from 'react';
import styled from 'styled-components';

const VerticalScroll = styled.div`
max-height: ${props => props.maxHeight || '500px'};
overflow-y: ${props => props.overflow || 'scroll'};
overflow-x: ${props => props.overflow || 'hidden'};
padding-left: ${props => props.pl || ''};
padding-right: ${props => props.pr || ''};
margin-left: ${props => props.ml || ''};
margin-right: ${props => props.mr || ''};
  ::-webkit-scrollbar {
    width: 3px;
    scroll-size: 2px; 
  }
  ::-webkit-scrollbar-thumb {
    height: ${props => props.scrollHeight || '4px'}
    background: ${props => props.color || '#A4B0CC'}
    border-radius: ${props => props.borderRadius || '10px'}
  }
  ::-webkit-scrollbar-track {
    border-radius: ${props => props.trackRadius || '6px'};
  }
`
const VerticalScrollBar = (props)=> {
  return (
    <VerticalScroll
      maxHeight={props.maxHeight}
      overflow={props.overflow}
      scrollHeight={props.scrollHeight}
      borderRadius={props.borderRadius}
      trackRadius={props.trackRadius}
      color={props.color}
      pl={props.pl}
      pr={props.pr}
      ml={props.ml}
      mr={props.mr}
    >
      {props.children}
    </VerticalScroll>
  )
}

export default VerticalScrollBar;